import { MenuItemType } from '@/components/Menu/types'
import { PATHS_WITH_SECTIONS, getSubsectionLink } from '@/router/RoutesUtils'

import { AdminPanelIcons } from '../Icons'

export const ADMIN_PANEL_PAGES = {
  MEMBERS: 'Members',
  LAW_FIRM_INFO: 'Law Firm Info',
  INTEGRATION: 'Integrations',
  BLOCKLIST: 'Block List',
  PAYMENTS: 'Payments',
  REFERRAL_SETTINGS: 'Case Settings',
  DIRECT_SHARE_API: 'Direct Share API & Webhooks',
}

export const getMenuItems = ({
  showReferralSettings,
}: {
  showReferralSettings?: boolean
} = {}): MenuItemType[] => [
  {
    sectionTitle: '',
    items: [
      {
        label: ADMIN_PANEL_PAGES.LAW_FIRM_INFO,
        icon: <AdminPanelIcons.LawFirmInfo sx={{ fontSize: '1rem' }} />,
      },
      {
        label: ADMIN_PANEL_PAGES.MEMBERS,
        icon: <AdminPanelIcons.Members sx={{ fontSize: '1rem' }} />,
      },
      {
        label: ADMIN_PANEL_PAGES.INTEGRATION,
        icon: <AdminPanelIcons.Integrations sx={{ fontSize: '1rem' }} />,
      },
      ...(showReferralSettings
        ? [
            {
              label: ADMIN_PANEL_PAGES.REFERRAL_SETTINGS,
              icon: (
                <AdminPanelIcons.ReferralSettings sx={{ fontSize: '1rem' }} />
              ),
            },
          ]
        : []),
      {
        label: ADMIN_PANEL_PAGES.PAYMENTS,
        icon: <AdminPanelIcons.Payments sx={{ fontSize: '1rem' }} />,
      },
      {
        label: ADMIN_PANEL_PAGES.DIRECT_SHARE_API,
        icon: <AdminPanelIcons.DirectShareApi sx={{ fontSize: '1rem' }} />,
      },
      {
        label: ADMIN_PANEL_PAGES.BLOCKLIST,
        icon: <AdminPanelIcons.BlockList sx={{ fontSize: '1rem' }} />,
      },
    ],
  },
]

export const getAdminPanelFirstLabel = (menuItems: MenuItemType[]) =>
  menuItems?.[0]?.items?.[0]?.label
export const getAdminPanelFirstLink = (menuItems?: MenuItemType[]) =>
  getSubsectionLink(
    PATHS_WITH_SECTIONS.ADMIN_PANEL,
    getAdminPanelFirstLabel(menuItems || getMenuItems({}))
  )
